export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10165.b18bf745.jpg";